//helpers
import { getCompositeId, groupActivitiesByDate } from  '@/helpers/ActivityFeed';
import useInfiniteScroll from  '@/components/hooks/utility/useInfiniteScroll';
import useShowNewNotifications from  '@/components/hooks/activityfeed/useShowNewNotifications';

//interfaces
import { IActivityListProps, UserGeneratedActivities } from  '@/interfaces/activityFeed';

//components
import {BasicTooltip, InformationOval, LoadingSpinner} from "thrive-components";
import CommentActivity from './CommentActivity';
import ModerationActivity from './ModerationActivity';
import ContentActivity from './ContentActivity';
import UserGeneratedActivity from './UserGeneratedActivity';





const ActivityList = ({isPopOut, activities, showNoMoreActivitiesMessage, getMoreActivities} : IActivityListProps) => { 
    const activitiesGroupedByDate = groupActivitiesByDate(activities);
    const infiniteScrollRef = useInfiniteScroll(getMoreActivities, showNoMoreActivitiesMessage === false) ?? undefined;
    let decrementCount = 0;
    const { isNewElement } = useShowNewNotifications();

    return (<>
        {activitiesGroupedByDate.map(({ dateLabel, longDateLabel, groupedActivities }) => (
            <div key={dateLabel} className="activity-group">
                <BasicTooltip className='information-oval-tooltip above' text={longDateLabel}>
                    <InformationOval information={dateLabel} />
                </BasicTooltip>
                
                {groupedActivities.map((activity: any, index: number) => {
                    let ActivityComponent = null;
                    const id = getCompositeId(activity.activityType, activity.author?.id, activity.createdAt);

                    const zIndex = activities.length - decrementCount;
                    
                    if (activity.activityType.includes("moderated") || activity.activityType.includes("objectionable")) {
                        ActivityComponent = <ModerationActivity zIndexNum={zIndex} isPopOut={isPopOut} activity={activity} />;
                    } else if (activity.activityType.includes("content")) {
                        ActivityComponent = <ContentActivity zIndexNum={zIndex} isPopOut={isPopOut} activity={activity} />;
                    } else if (activity.activityType.includes("comment")) {
                        ActivityComponent = <CommentActivity zIndexNum={zIndex} isPopOut={isPopOut} activity={activity} />;
                    } else if (UserGeneratedActivities.includes(activity.activityType)) {
                        ActivityComponent = <UserGeneratedActivity zIndexNum={zIndex} isPopOut={isPopOut} activity={activity} />;
                    }
                    
                    decrementCount++;

                    return (
                        <div key={id} id={id} className={isNewElement(id) ? 'is-new' : 'old'}>
                            {ActivityComponent}
                            <span className={`${groupedActivities.length > 1 && index < groupedActivities.length - 1 ? "activity-divider" : "hidden-activity-divider"}`} />
                        </div>
                    );
                })}
            </div>
        ))}
        
        <div data-testid="infinite-scroll" ref={infiniteScrollRef} />

        {showNoMoreActivitiesMessage 
            ? <span className="no-more-activities-message" >No more activities to show</span>
            : <LoadingSpinner size={20} />
        }
    </>);
}
export default ActivityList



